const menu = [
  {
    id: 1,
    title: 'Bife Ancho',
    category: 'Carnes',
    price: 164,
    img: './images/ancho.avif',
    desc: 'Corte alto da parte mais nobre do lombo bovino. Serve 1 Pessoa (320g)',
  },
  {
    id: 12,
    title: 'Arroz Biro-Biro',
    category: 'Acompanhamentos',
    price: 59,
    img: './images/biro.webp',
    desc: 'Tradicional arroz branco com linguiça, cebola, salsinha, ovos picados e batata palha.',
  },  
  {
  
    id: 2,
    title: 'Mix Especial de Chorizo',
    category: 'Tapas',
    price: 45.99,
    img: './images/mix.avif',
    desc: `Salsicha parrillera, linguiça tradicional e de cordeiro `,
  },
  {
    id: 3,
    title: 'Torta de Chocolate',
    category: 'Sobremesas',
    price: 49,
    img: './images/torta.avif',
    desc: `Irresistível torta de chocolate do Pobre Juan`,
  },
  {
    id: 4,
    title: 'Pudim de Doce de leite',
    category: 'Sobremesas',
    price: 34,
    img: './images/pudim.jpg',
    desc: `Pudim de Dulce de Leche, preparado com o autêntico doce de leite argentino. `,
  },
  {
    id: 5,
    title: 'Churros de Doce de leite',
    category: 'Sobremesas',
    price: 34,
    img: './images/churros.jpg',
    desc: `Pudim de Dulce de Leche, preparado com o autêntico doce de leite argentino. `,
  },
  {
    id: 6,
    title: 'Empanada de carne',
    category: 'Tapas',
    price: 34,
    img: './images/empanada.webp',
    desc: `Tradicional empanada Argentina de carne com tempero portenho (1unidade)`,
  },
  {
    id: 7,
    title: 'Croquetas de Jamón',
    category: 'Tapas',
    price: 46,
    img: './images/jamon.webp',
    desc: `Bolinhas cremosas de bechamel com brunoise de Jamón Espanhol e queijo parmesão.`,
  },
  {
    id: 8,
    title: 'Mini Empanadas',
    category: 'Tapas',
    price: 40,
    img: './images/mini.webp',
    desc: `Porção de tradicionais empanadas Argentinas: sabores carne com tempero portenho e queijo mozarela. (6 unidades)`,
  },
  {
    id: 9,
    title: 'Croquetas de Ossobuco',
    category: 'Tapas',
    price: 46,
    img: './images/ossobuco.avif',
    desc: 'Bolinhas cremosas recheadas de ossobuco e queijo parmesão. Acompanha geléia de pimenta ',
  },
  {
    id: 10,
    title: 'Bife de Choriço',
    category: 'Carnes',
    price: 128,
    img: './images/chorico.webp',
    desc: 'Corte transversal do lombo bovino com leve capa de gordura. Serve 1 pessoa (280g)' ,
  },  
  {
    id: 11,
    title: 'Bife Pobre Juan',
    category: 'Carnes',
    price: 171,
    img: './images/bifejuan.avif',
    desc: 'Corre especial do bife ancho, macio, saboroso e muito marmorizado. Serve 1 pessoa (270g)' ,
  },  
  {
  id: 13,
    title: 'Farofa de Ovos',
    category: 'Acompanhamentos',
    price: 49,
    img: './images/ovos.webp',
    desc: 'Farofa de mandioca tostada com ovos e cebolinha verde'
    ,
  },  
  {
    id: 14,
      title: 'Farofa Pobre Juan',
      category: 'Acompanhamentos',
      price: 51,
      img: './images/farofa.webp',
      desc: 'Farofa puxada com cebolas finas empanadas e fritas na manteiga.',
    },  
];
export default menu;
